// @flow
import styled from "styled-components";

export const FlexDivColCenter = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;